import { defaultAnchorSpec, type AnchorSpec } from '@ar-suite/core'
import type { ProceduralRingOptions } from './procedural'

export interface ProceduralRingProduct {
  id: string
  name: string
  procedural: Partial<ProceduralRingOptions>
  anchor: AnchorSpec
}

function spec(patch: Partial<AnchorSpec> = {}): AnchorSpec {
  const s = defaultAnchorSpec('ring')
  s.unitScale = 1
  return Object.assign(s, patch)
}

export const PROCEDURAL_RINGS: ProceduralRingProduct[] = [
  { id: 'ring-band-gold', name: 'Band · Gold', procedural: { style: 'band' }, anchor: spec() },
  { id: 'ring-solitaire', name: 'Solitaire · Diamond', procedural: { style: 'solitaire' }, anchor: spec() },
  { id: 'ring-signet', name: 'Signet · Gold', procedural: { style: 'signet' }, anchor: spec({ ring: { finger: 'index', hand: 'any' } }) },
]
